import { configureStore } from "@reduxjs/toolkit"

import accountInfoReducer from "./reducers/accountInfo"
import diveSitesReducer from "./reducers/diveSites"
import { errorsReducer, notificationsReducer } from "./reducers/errors"
import loaderReducer from "./reducers/loader"
import localStorageReducer from "./reducers/localStorage"
import specialistsReducer from "./reducers/specialists"
import speciesReducer from "./reducers/species"

export default configureStore({
  reducer: {
    accountInfo: accountInfoReducer,
    diveSites: diveSitesReducer,
    errors: errorsReducer,
    notifications: notificationsReducer,
    loader: loaderReducer,
    localStorage: localStorageReducer,
    specialists: specialistsReducer,
    species: speciesReducer
  }
})